import PropTypes from 'prop-types';

export const itemShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    starred: PropTypes.bool,
    dueDate: PropTypes.string,
    position: PropTypes.number,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
});

export const checklistShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(itemShape).isRequired,
    groupId: PropTypes.string,
    sortMode: PropTypes.string,
    sinkCheckedItems: PropTypes.bool,
    hideCheckedItems: PropTypes.bool,
});

export const groupShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
});

export const templateItemShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    position: PropTypes.number,
    createdAt: PropTypes.string,
});

export const templateShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    itemCount: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(templateItemShape),
    createdAt: PropTypes.string,
});
